/*
* Connects the client side with socket.io to the server-side and displays the data to the user.
*/

import 'phaser'
import Preload from 'preloader'
var request = require('browser-request')

export default class Game extends Phaser.Scene {

  constructor() {
    super({ key: 'game' });
  }

  preload() {
    this.width = this.sys.game.canvas.width;
    this.height = this.sys.game.canvas.height;
    this.centerX = this.width / 2;
    this.centerY = this.height / 2;
    this.working = false;
    this.musicSound = this.sound.add('music', { loop: true, volume: 0.1 });
  }

  create() {
    document.getElementById('prompt').addEventListener('mousedown', (e) => {
      e.stopPropagation();
    });
    this.input.on('gameobjectdown', this.handleClicks, this);
    this.bg = this.add.image(this.centerX, this.centerY, 'background');
    this.bg.setInteractive({ useHandCursor: true });
    this.bg.name = 'ball';
    this.ball = this.add.image(this.centerX, this.centerY, 'ball');
    this.ball.setInteractive({ useHandCursor: true });
    this.ball.name = 'ball';
    this.bar = this.add.image(this.centerX, this.centerY + 300, 'bar');
    this.unmuted = this.add.image(this.centerX + 450, this.centerY - 300, 'unmuted');
    this.unmuted.alpha = 0.05;
    this.unmuted.setInteractive({ useHandCursor: true });
    this.unmuted.name = 'unmuted';
    this.muted = this.add.image(this.centerX + 450, this.centerY - 300, 'muted');
    this.muted.alpha = 0.05;
    this.muted.setInteractive({ useHandCursor: true });
    this.muted.name = 'muted';
    this.muted.visible = false;
    this.screenshot = this.add.image(this.centerX - 450, this.centerY - 300, 'screenshot');
    this.screenshot.alpha = 0.05;
    this.screenshot.setInteractive({ useHandCursor: true });
    this.screenshot.name = 'screenshot';
    this.screenshot.visible = false;
    this.profile = this.add.image(this.centerX - 450, this.centerY - 300, 'profile');
    this.profile.alpha = 0.05;
    this.profile.setInteractive({ useHandCursor: true });
    this.profile.name = 'profile';
    this.profile.visible = false;
    this.anims.create({
        key: 'y8ball',
        frames: [
            { key: 'y8ball0000', frame: null },
            { key: 'y8ball0001', frame: null },
            { key: 'y8ball0002', frame: null },
            { key: 'y8ball0003', frame: null },
            { key: 'y8ball0004', frame: null },
            { key: 'y8ball0005', frame: null },
            { key: 'y8ball0006', frame: null },
            { key: 'y8ball0007', frame: null },
            { key: 'y8ball0008', frame: null },
            { key: 'y8ball0009', frame: null },
            { key: 'y8ball0010', frame: null },
            { key: 'y8ball0011', frame: null },
            { key: 'y8ball0012', frame: null },
            { key: 'y8ball0013', frame: null },
            { key: 'y8ball0014', frame: null },
            { key: 'y8ball0015', frame: null },
            { key: 'y8ball0016', frame: null },
            { key: 'y8ball0017', frame: null },
            { key: 'y8ball0018', frame: null },
            { key: 'y8ball0019', frame: null, duration: 50 }
        ],
        frameRate: 12,
        repeat: 1
    });
    
    this.stopParticles();
    this.musicSound.play();
  }

  getResponse() {
    request.post({
      url:'/api/generation',
      form: { prompt: document.getElementById('prompt').value }
    }, (err, httpResponse, body) => {
      var data = JSON.parse(body);
      if (data.success) {
        this.response = data.results;
        if (this.response.split('.').length > 1) {
          this.response = this.response.split('.')[0];
        }
        if (this.response.split('?').length > 1) {
          this.response = this.response.split('?')[0];
        }

        this.response = this.response.split('<|endoftext|>').join('');

        if (this.response == '') {
          this.response = 'Things are fuzzy, I need a better prompt please.';
        }

      } else {
        this.response = 'Something is broken. Please try again later.';
      }

      this.tryRenderPrediction();
    });
  }

  tryRenderPrediction() {
    if (this.animationready) {
      this.renderPrediction();
    } else {
      setTimeout(() => {
        this.tryRenderPrediction() 
      }, 100)
    }
  }

  renderPrediction() {
    this.screenshot.visible = true;
    this.fortuneText = this.make.text({
      x: this.centerX + 5,
      y: this.centerY - 30,
      origin: { x: 0.5, y: 0.5 },
      text: this.response,
      depth: 1,
      style: {
        font: 'bold 16px Arial',
        fill: 'black',
        wordWrap: { width: 135 }
      }
    });
    this.fortuneText.alpha = 0;
    setTimeout(() => {
      this.tweens.add({
        targets: this.fortuneText,
        alpha: 1,
        duration: 1000,
        repeat: 0,
        onComplete: () => {
          this.working = false;
        }
      });
    }, 500)
  }

  createParticles() {
    var count = 0;
    var particleTimer = setInterval(() => {
      count++;
      if (count > 4) {
        clearInterval(particleTimer)
      }
      var particle = this.add.image(this.centerX + Phaser.Math.Between(-500, 500), this.centerY + 300, 'particle');
      particle.depth = 2;
      var diration = 3000 + Phaser.Math.Between(1250, 1500);
      particle.alpha = 1;
      particle.scale = Phaser.Math.Between(35, 75) / 100;
      this.tweens.add({
        targets: particle,
        y: this.centerY - 400 + Phaser.Math.Between(1, 100),
        alpha: 1,
        ease: 'Sine.easeInOut',
        duration: diration,
        repeat: 0,
        yoyo: false
      });
      this.tweens.add({
        targets: particle,
        alpha: 0,
        ease: 'Sine.easeInOut',
        delay: diration,
        duration: 500,
        repeat: 0,
        yoyo: false,
        onComplete: function () { particle.destroy(); },
      });
      this.tweens.add({
        targets: particle,
        x: particle.x + Phaser.Math.Between(-100, 100),
        ease: 'Sine.easeInOut',
        duration: 1000,
        repeat: 2,
        yoyo: true
      });
    }, 500)

  }

  startParticles() {
    this.createParticles();
    this.tweens.add({
      targets: this.ball,
      x: this.ball.x + 5,
      ease: 'Sine.easeInOut',
      duration: 500,
      repeat: 2,
      yoyo: true
    });
    this.tweens.add({
      targets: this.spinning,
      x: this.spinning.x + 5,
      ease: 'Sine.easeInOut',
      duration: 500,
      repeat: 2,
      yoyo: true
    });
  }

  stopParticles() {
    
  }

  takeScreenshot(callback) {
    this.screenshotText = this.make.text({
      x: this.centerX,
      y: this.centerY + 300,
      origin: { x: 0.5, y: 0.5 },
      text: this.prompt,
      style: {
        font: 'bold 18px Arial',
        fill: 'white',
        wordWrap: { width: 950 }
      }
    });
    this.game.renderer.snapshot((image) => {
      ID.submit_image(image.src, (res) => {
        this.screenshotText.destroy();
        callback();
      });
    }, 'image/jpeg');
  }

  async handleClicks(pointer, object) {
    if (object.name == 'screenshot') {
      ID.getLoginStatus((response) => {
        if (response && response.status == 'ok') {
          this.takeScreenshot(() => {
            this.screenshot.visible = false;
            this.profile.visible = true;
          });
        } else {
          ID.login((response) => {
            if (response && response.authResponse.status == 'ok') {
              this.takeScreenshot(() => {
                this.screenshot.visible = false;
                this.profile.visible = true;
              });
            }
          })
        }
      }, false)
    }
    if (object.name == 'unmuted') {
      this.unmuted.visible = false;
      this.muted.visible = true;
      this.musicSound.pause();
    }
    if (object.name == 'muted') {
      this.unmuted.visible = true;
      this.muted.visible = false;
      this.musicSound.resume();
    }
    if (object.name == 'profile') {
      ID.openProfile()
    }

    var prompt = document.getElementById('prompt').value;
    this.prompt = prompt;
    if (object.name == 'ball' && this.working == false && prompt) {
      this.screenshot.visible = true;
      this.profile.visible = false;
      if (this.spinning) { this.spinning.destroy(); }
      if (this.piece) { this.piece.destroy(); }
      if (this.fortuneText) { this.fortuneText.destroy(); }
      if (this.window) { this.window.destroy(); }
      this.animationready = false; 

      this.working = true;
      this.getResponse()

      
      document.getElementById('prompt').style.opacity = 1;
      var clearPrompt = setInterval(() => {
        document.getElementById('prompt').style.opacity -= 0.01;
        if (document.getElementById('prompt').style.opacity <= 0) {
          document.getElementById('prompt').value = '';
          document.getElementById('prompt').style.opacity = 1;
          clearInterval(clearPrompt);
        }
      }, 40)
      this.spinning = this.add.sprite(this.centerX, this.centerY - 40, 'y8ball0019').play('y8ball');
      this.startParticles();
      this.spinning.once(Phaser.Animations.Events.SPRITE_ANIMATION_COMPLETE, () => {
        this.stopParticles();
        this.spinning.destroy();
        this.window = this.add.sprite(this.centerX, this.centerY - 40, 'y8ball0019');
        this.window.depth = 1;
        this.piece = this.add.sprite(this.centerX + 5, this.centerY - 30, 'piece');
        this.piece.depth = 1;
        this.piece.alpha = 0;
        this.tweens.add({
          targets: this.piece,
          alpha: 1,
          duration: 1900,
          repeat: 0,
          onComplete: () => { this.animationready = true; }
        });
      })
    }
  }
}
